import React, { useState, useEffect, ReactNode } from 'react'
import { Services } from '@/services/services'
import { NavBar } from './NavBar'
import { Translates } from '@/services/repository/i18n'
import { useLocation, useNavigate } from 'react-router-dom'
import { isDesktopScreen, useResponsiveChange } from '@/common/device'
import { useModal } from '../modal/Modal'
import { NavigationMenu, NavigationRow } from './Navigation'

import './CommunalLayout.css'
import { LangsButton } from './Langs'

export interface CommunalLayoutParams {
  pageName: string
  services: Services
  translates: Translates
  children: ReactNode
  path?: NavigationRow[]
  navbarLeft?: ReactNode
  navbarRight?: ReactNode
}

export const LangsPopup = ({ services, translates, onClose }: { services: Services, translates: Translates, onClose: () => void }) => {
  const defaultLangCode = services.i18n.defaultLang()

  function langRow(title: string, code: string) {
    return <li onClick={() => {
      services.i18n.setDefaultLang(code)
      window.location.reload();
      onClose()
    }} className={defaultLangCode === code ? 'current' : ''}>
      <div className='title'>{title}</div>
      <img src={`/public/img/flags/${code}.svg`} />
    </li>
  }
  return <div className='layout-navbar-langs'>
    <ul>
      {Object.values(services.i18n.langData()).map((lang) => langRow(lang.title, lang.id))}
    </ul>
  </div>
}


export const CommunalLayout = ({ pageName, translates, services, children }: CommunalLayoutParams) => {
  const navigate = useNavigate()
  const location = useLocation()

  useResponsiveChange()

  function redirect(url: string, external: boolean) {
    if (!external) {
      navigate(url)
      return
    }
    window.location.href = url
  }

  interface liProps {
    external?: boolean
    ico?: string
    onClick?: () => void
  }

  function li(title: string, url: string, row: liProps) {
    const { onClick = undefined, ico = undefined, external = false } = row
    return <li onClick={() => onClick ? onClick() : redirect(url, external)} className={location.pathname === url ? 'current' : ''}>
      <div className='wrap'>
        {isDesktopScreen() ? title : null}
        {ico ? <i className={'arrow ' + ico}></i> : <i className='svgfont-arrow-down arrow'></i>}
      </div>
    </li>
  }

  return <div className='communal-layout'>
    <nav className='communal-navbar'>
      <LangsButton services={services} translates={translates} />
    </nav>
    <section className={`${pageName}-page content-body`}>
      {children}
    </section>
  </div>
}

export const CommunalPageLayout = (params: CommunalLayoutParams) => {
  return <CommunalLayout {...params}>
    <NavigationMenu translates={params.translates} title={params.pageName} path={params.path}></NavigationMenu>
    {params.children}
  </CommunalLayout>
}